module.exports = __webpack_public_path__ + "img/组 6.e6d2eb3a.png";